export default __webpack_public_path__ + "static/media/logo.cfd1a9fb.png";